export default __webpack_public_path__ + "4e8f80428514e50c3ebe901cd2d5f2f9.png";